import React from 'react';
import BasicButton from './Button/BasicButton';
import BasicTextfield from './Text/BasicTextfield';
import HorizontalLineText from './Text/HorizontalLineText';
import Colortheme from '../Theme/Colortheme';
import { AvatarChooser, randomAvatar } from './Players/AvatarChooser';
import Divider from './HelperElements/Divider';
import alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.css';
import Cookies from 'js-cookie'
import { randomUsername } from '../Utils/UsernameGenerator'
import Discord from './Social/Discord';
import Credits from './Social/Credits';
import { messyBorderStyle } from '../Utils/StyleUtils';
import URLs from '../Utils/URLUtils';
import FeaturedArt from './FeaturedArt';
import TipsAndTricks from './Text/TipsAndTricks';

class Startpage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            avatar: randomAvatar(),
            name: Cookies.get("displayName") ?? randomUsername(),
            lobbyCode: this.props.location.state?.lobbyCode?.toUpperCase() ?? "",
        }

        this.style = {
            centerField: {
                padding: '20px',
                margin: '10px',
                backgroundColor: '#FFFFFF',
                maxWidth: '500px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                ...messyBorderStyle("main_startpage"),
            },
        };

        this.avatarUpdated = this.avatarUpdated.bind(this);
        this.nameUpdated = this.nameUpdated.bind(this);
        this.lobbyCodeUpdated = this.lobbyCodeUpdated.bind(this);
        this.hostGame = this.hostGame.bind(this);
        this.hostOrJoinGame = this.hostOrJoinGame.bind(this);
        this.joinGame = this.joinGame.bind(this);
        this.displayHostGame = this.displayHostGame.bind(this);
    }

    avatarUpdated(avatar) {
        var name = this.state.name
        if (!Cookies.get("displayName")) {
            name = randomUsername()
        }
        this.setState({ avatar: avatar, name: name });
    }

    nameUpdated(event) {
        if (event.target.value) {
            Cookies.set("displayName", event.target.value, { expires: 5000, secure: true, sameSite: 'lax' })
        } else {
            Cookies.remove("displayName")
        }
        this.setState({ name: event.target.value });
    }

    lobbyCodeUpdated(event) {
        this.setState({ lobbyCode: event.target.value.toUpperCase() });
    }

    randLobbyCode() {
        const dict = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        var result = '';
        for (var i = 0; i < 6; i++) {
            result += dict[Math.floor(Math.random() * dict.length)];
        }
        return result
    }

    async startGame(lobbyCode) {
        if (lobbyCode) {
            var response = await fetch(URLs.apiURL + "/lobbystatus?code=" + lobbyCode);
            var data = await response.json();
            if (data.status === 'none') {
                alertify.warning('This game code does not exist')
                return
            }
        } else {
            var response = await fetch(`${URLs.apiURL}/newlobbycode`);
            lobbyCode = await response.text();
        }
        if (Cookies.get("userID")) {
            this.props.history.push({
                pathname: `/lobby/${encodeURIComponent(lobbyCode)}`,
                state: {
                    playername: this.state.name,
                    avatar: this.state.avatar,
                }
            });
        } else {
            this.props.history.push({
                pathname: `/tutorial`,
                state: {
                    playername: this.state.name,
                    avatar: this.state.avatar,
                    lobbyCode: lobbyCode
                }
            });
        }
    }

    joinGame() {
        if (!this.state.name) {
            alertify.warning('Please enter a player name')
            return
        }
        if (!this.state.lobbyCode) {
            alertify.warning('Please enter a lobby code')
            return
        }
        this.startGame(this.state.lobbyCode);
    }

    hostOrJoinGame() {
        if (!this.state.name) {
            alertify.warning('Please enter a player name')
            return
        }

        if (!this.state.lobbyCode) {
            this.startGame()
        } else {
            this.startGame(this.state.lobbyCode)
        }
    }

    hostGame() {
        if (!this.state.name) {
            alertify.warning('Please enter a player name')
            return
        }
        this.startGame()
    }

    displayHostGame() {
        if (!this.props.location.state?.lobbyCode) {
            return <div>
                <HorizontalLineText margin={'10px'}>Or</HorizontalLineText>
                <BasicButton style={{ minWidth: '100%' }} height={'50px'} onClick={this.hostGame}>Host Game</BasicButton>
            </div>;
        }
    }

    render() {
        return (
            <div>
                <div style={this.style.centerField}>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <BasicTextfield flex={2} height={'50px'} placeholder={'Name'} value={this.state.name} onChange={this.nameUpdated} onSubmit={this.hostOrJoinGame}></BasicTextfield>
                        <AvatarChooser flex={1} height={'50px'} avatar={this.state.avatar} onAvatarUpdated={this.avatarUpdated} style={{ paddingLeft: "1em" }} />
                    </div>
                    <Divider height={'10px'} />
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <BasicTextfield flex={2} height={'50px'} placeholder={'Code'} margin={'0px 10px 0px 0px'} value={this.state.lobbyCode} onChange={this.lobbyCodeUpdated} onSubmit={this.joinGame}></BasicTextfield>
                        <BasicButton flex={1} height={'50px'} onClick={this.joinGame}>Join</BasicButton>
                    </div>
                    {this.displayHostGame()}
                </div>
                <TipsAndTricks maxWidth={"500px"} />
                <Discord />
                <Credits showTutorialLink={true} />
                <div style={{
                    paddingTop: '1em',
                    paddingBottom: '1em',
                }}>
                    <FeaturedArt />
                </div>
            </div>
        );
    }
}

export default Startpage;